import { GeneralSettings } from "../settings/GeneralSettings";

export class WindowTitleProvider {
    private static singleton: WindowTitleProvider;

    public static get(): WindowTitleProvider {
        this.initialize();
        return this.singleton;
    }

    public static set(provider: WindowTitleProvider) {
        this.singleton = provider;
    }

    static initialize() {
        // If a provider has not been supplied for a specific web app, use the common one (this class).
        if (this.singleton == null)
            this.singleton = new WindowTitleProvider();
    }

    finalizeTitle(title: string): string {
        return this.addEnvironmentMessage(title);
    }

    protected addEnvironmentMessage(title: string): string {
        const envMessage = GeneralSettings.get()?.environment_message;
        return envMessage?.length > 0 ? (envMessage + " " + title) : title;
    }

    public get defaultTitle(): string {
        return "McLeod Portal";
    }
}
